module.exports = __webpack_public_path__ + "static/media/koryu_00003p.436658f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00003p.png
// module id = 206
// module chunks = 0